<template>
	<div class="d-flex align-items-center" :class="canEdit ? 'justify-content-between px-2' : 'justify-content-center'">
		<span class="mr-2 d-inline-block text-nowrap">{{ data.label }}</span>
		<b-button :id="triggerID" size="sm" variant="link" class="bg-white p-0 m-0 h-100 rounded" tabindex="0" v-if="canEdit">
			<component :is="getLucideIcon('Edit')" :size="20" class="px-1" color="#225CBD" :stroke-width="2.5" />
		</b-button>
		<b-popover :target="triggerID" placement="auto" :custom-class="customClass" triggers="focus" v-if="canEdit">
			<template #title>{{ FormMSG(1, 'Column settings') }}</template>
			<div class="d-flex flex-column w-100">
				<b-form-group :label="FormMSG(61, 'Category')" v-if="isColumnCostCode">
					<cost-center-select
						:all-categories="allCategories"
						:edit-data="globalCostCode"
						:append-to-body="false"
						@change="(e) => setGlobalCostCode(e)"
						:expend-menu="expendMenu"
					/>
				</b-form-group>
				<b-form-group :label="`${FormMSG(2, 'Tax code')}`" v-else-if="isColumnTaxCode">
					<v-select
						ref="flag-item"
						label="text"
						:options="taxOptions"
						:reduce="(option) => option.value"
						:get-option-label="(option) => (option.item ? option.item.factor : '')"
						placeholder="..."
						@input="setGlobalTaxCode($event)"
					>
						<template #option="option">
							<div class="text-bold" v-if="option.disabled">{{ option.text }}</div>
							<div class="text-color ml-3" v-else>{{ option.text }} - {{ option.item.name }} ({{ option.item.factor }}%)</div>
						</template>
					</v-select>
				</b-form-group>
				<b-form-group :label="`${data.label}`" class="w-100" v-else-if="isColumnCustomFlag">
					<v-select
						label="name"
						placeholder="..."
						:options="projectFlagItem"
						:reduce="(option) => option.id"
						@input="setGlobalCustomFlag($event, projectFlagItem)"
					/>
				</b-form-group>
				<b-button size="sm" variant="success" class="rounded" @click="computePropagation" :disabled="disableComputeCostCode">
					<component :is="getLucideIcon('Check')" :size="18" color="#fff" :stroke-width="2.5" />
					{{ FormMSG(3, 'Compute') }}
				</b-button>
			</div>
		</b-popover>
	</div>
</template>

<script>
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';

// component
import CostCenterSelect from './CostCodeSelect';

// utils
import { isNil } from '@/shared/utils';

export default {
	name: 'ExpenseItemDataPropagation',
	mixins: [globalMixin, languageMessages],
	components: {
		CostCenterSelect
	},
	props: {
		triggerID: {
			type: String,
			required: true
		},
		canEdit: {
			type: Boolean,
			required: true,
			default: true
		},
		customClass: {
			type: String,
			required: false,
			dafault: ''
		},
		isColumnTaxCode: {
			type: Boolean,
			required: false,
			default: false
		},
		isColumnCostCode: {
			type: Boolean,
			required: false,
			default: false
		},
		isColumnCustomFlag: {
			type: Boolean,
			required: false,
			default: false
		},
		data: {
			type: Object,
			required: true,
			default: () => {}
		},
		taxOptions: {
			type: Array,
			required: false,
			default: () => []
		},
		projectFlagItem: {
			type: Array,
			required: false,
			default: () => []
		},
		allCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		expendMenu: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			globalCostCode: {
				category: 0,
				costCenter: 'UNDEFINED',
				categoryName: 'UNDEFINED'
			},
			disableComputeCostCode: false,
			globalTaxCode: [],
			globalCustomFlag: {}
		};
	},
	created() {
		this.disableComputeCostCode = this.isColumnCostCode;
	},
	methods: {
		setGlobalCostCode(payload) {
			this.globalCostCode.category = payload.costcodeText ? +payload.category : this.globalCostCode.category;
			this.globalCostCode.costCenter = payload.costcodeText ? payload.costcodeText : this.globalCostCode.costCenter;
			this.globalCostCode.categoryName = payload.categoryText ? payload.categoryText : this.globalCostCode.categoryName;
			if (!isNil(+this.globalCostCode.category) && !isNil(this.globalCostCode.costCenter)) this.disableComputeCostCode = false;
		},
		setGlobalTaxCode(payload) {
			if (payload) {
				this.globalTaxCode[0] = this.taxOptions.filter((tax) => +payload === +tax.value)[0].item;
			} else this.globalTaxCode = [];
		},
		setGlobalCustomFlag(payload, customFlag) {
			this.globalCustomFlag = customFlag.find((flag) => +flag.id === +payload);
		},
		computePropagation() {
			if (this.isColumnCostCode) {
				this.$emit('computePropagation', this.globalCostCode);
				this.globalCostCode = {
					category: 0,
					costCenter: 'UNDEFINED',
					categoryName: 'UNDEFINED'
				};
				this.disableComputeCostCode = true;
			} else if (this.isColumnTaxCode) {
				this.$emit('computePropagation', this.globalTaxCode);
				this.globalTaxCode = [];
			} else if (this.isColumnCustomFlag) {
				this.$emit('computePropagation', this.globalCustomFlag);
				this.globalCustomFlag = {};
			}
			this.$root.$emit('bv::hide::popover', this.triggerID);
		}
	}
};
</script>
